/**
 * section-event-signup.js
 *
 * 이벤트 뉴스레터 가입 페이지 JS
 * Event newsletter signup page JavaScript.
 *
 * 주요 기능 / Key responsibilities:
 * 1. 폼 제출 직전(네비게이션 전)에 Klaviyo Identify 전송
 *    Fire Klaviyo Identify BEFORE navigation (while the page is still stable).
 *    이유: Markets 멀티도메인 환경에서 POST→리디렉션 시 오리진이 바뀌어
 *    sessionStorage가 소실됨. 리디렉션 후 전송 방식은 사라진 데이터 때문에 실패함.
 *    Why: In Markets multi-domain setups the origin changes across the POST→redirect,
 *    causing sessionStorage to be lost. Sending after redirect fails because the blob
 *    is gone. Sending BEFORE navigation is the only reliable approach.
 *    keepalive: true 로 비행 중 요청도 완료되도록 보장
 *    keepalive: true ensures the in-flight request completes even if navigation starts.
 * 2. 제출 전 Full Name을 first / last로 분리 (필드가 있는 경우)
 *    Before submit: split Full Name into first / last (only when the field exists).
 * 3. ?customer_posted=true 감지 후 성공 모달 표시 (Klaviyo 재호출 없음)
 *    On load with ?customer_posted=true: show success modal. Klaviyo is NOT called
 *    again — it was already sent pre-navigation.
 * 4. 모달 접근성: focus trap, Esc 닫기, 포커스 복원
 *    Modal accessibility: focus trap, Esc-to-close, focus restoration.
 *
 * 모든 설정값은 data-* 속성에서 읽음 (하드코딩 없음)
 * All config values are read from data-* attributes — nothing hardcoded.
 */

(function () {
  'use strict';

  /* ============================================================
     섹션 루트 요소 찾기 / Locate section root element
     ============================================================ */

  // 섹션 래퍼에 data-* 속성이 있음
  // The section wrapper carries the data-* attributes.
  var section = document.querySelector('.section-event-signup');
  if (!section) return;

  /* ============================================================
     설정값 읽기 / Read configuration from data-* attributes
     ============================================================ */

  var klaviyoKey       = section.dataset.klaviyoKey || '';
  var klaviyoSignupEvt = section.dataset.klaviyoSignupEvent || '';

  /* ============================================================
     DOM 참조 / DOM references
     각 참조는 null 체크 후 사용 — 필드가 숨겨진 경우에도 JS 오류 없음
     Each reference is null-checked before use — no JS errors when a field is hidden.
     ============================================================ */

  var form          = document.getElementById('EventSignupForm');
  // visible 입력 필드: name="contact[first_name]" — JS가 전체 이름을 first로 덮어씀
  // Visible input with name="contact[first_name]" — JS overwrites with first-name token.
  var fullNameInput = document.getElementById('EventSignup-FullName');
  // 숨겨진 last_name 필드 — JS가 채움
  // Hidden last_name field — populated by JS.
  var lastNameInput = document.getElementById('EventSignup-LastName');
  var emailInput    = document.getElementById('EventSignup-Email');
  var cityInput     = document.getElementById('EventSignup-City');
  var countrySelect = document.getElementById('EventSignup-Country');
  // 전화번호 필드 — Klaviyo 전용 (Shopify contact 필드 아님)
  // Phone field — Klaviyo-only (not a Shopify contact field).
  // SMS 마케팅 동의는 별도 처리 사항으로 이 필드는 프로필 속성으로만 저장됨
  // SMS marketing consent is a separate concern; this only stores the number as a profile property.
  var phoneInput    = document.getElementById('EventSignup-Phone');

  var overlay  = document.getElementById('EventSignup-ModalOverlay');
  var modal    = document.getElementById('EventSignup-Modal');
  var closeBtn = document.getElementById('EventSignup-ModalClose');
  var doneBtn  = document.getElementById('EventSignup-ModalDone');

  /* ============================================================
     폼 제출 핸들러 / Form submit handler
     ============================================================ */

  if (form) {
    // 제출 버튼 참조 — requestSubmit()에 commit 버튼 전달용
    // Reference to the submit button — passed to requestSubmit() to replay the commit button.
    var submitBtn = form.querySelector('[type="submit"]');

    // 중복 실행 방지 플래그 / Guard flag to prevent duplicate execution.
    // Klaviyo 전송 완료 후 두 번째 submit 이벤트(네이티브 제출)는 이 플래그로 통과시킴
    // The 2nd submit event (native re-submission) is let through by this flag.
    var klaviyoHandled = false;
    // 제출 진행 중 플래그 — Klaviyo 응답 대기(최대 1.5초) 동안 더블탭 중복 전송 방지
    // In-progress flag — prevents a double-tap during the Klaviyo wait (up to 1.5s) from firing twice.
    var inProgress = false;

    form.addEventListener('submit', function (e) {
      // 두 번째 패스: 네이티브 제출 — 아무것도 하지 않고 통과
      // 2nd pass: native submission — do nothing, let it proceed.
      if (klaviyoHandled) return;

      // 대기 중 추가 제출(더블탭) 무시 — 네비게이션만 막고 종료
      // Ignore extra submits (double-tap) while waiting — block navigation and return.
      if (inProgress) {
        e.preventDefault();
        return;
      }
      inProgress = true;

      // 첫 번째 패스: Klaviyo 전송을 위해 네비게이션을 잠시 멈춤
      // 1st pass: pause navigation so we can send Klaviyo before redirect.
      // HTML5 유효성 검사는 submit 이벤트 발생 전에 완료됨 — 필수 필드 검사 우회 없음
      // HTML5 validation already ran before this event fires — no required-field bypass.
      e.preventDefault();

      // 버튼 로딩 상태 표시 (disabled 미사용 — requestSubmit(submitBtn) 동작 유지)
      // Show loading state on the button (NOT disabled — keeps requestSubmit(submitBtn) working).
      if (submitBtn) {
        submitBtn.setAttribute('aria-busy', 'true');
        submitBtn.classList.add('is-loading');
      }

      // ── 1. Full Name 분리 (필드가 존재하는 경우에만) ──
      // ── 1. Split Full Name (only when the field exists) ──
      var firstName = '';
      var lastName  = '';

      if (fullNameInput) {
        var fullName   = fullNameInput.value.trim();
        var spaceIndex = fullName.indexOf(' ');

        if (spaceIndex === -1) {
          // 공백 없음: 전체 값을 first_name으로, last_name은 빈 값
          // No space: entire value goes to first_name; last_name is empty.
          firstName = fullName;
          lastName  = '';
        } else {
          // 첫 번째 공백 기준으로 분리
          // Split on the first space: prefix → first_name, remainder → last_name.
          firstName = fullName.slice(0, spaceIndex);
          lastName  = fullName.slice(spaceIndex + 1).trim();
          // 분리된 first_name을 visible 입력에 다시 씀 (Shopify가 읽어감)
          // Write split first_name back into the visible input (Shopify will read it).
          fullNameInput.value = firstName;
        }

        if (lastNameInput) {
          lastNameInput.value = lastName;
        }
      }

      // ── 2. sessionStorage 없이 live 입력값으로 직접 Klaviyo 페이로드 구성 ──
      // ── 2. Build Klaviyo payload directly from live inputs — no sessionStorage ──
      // 이유: POST→리디렉션 시 sessionStorage가 소실되므로 제출 전에 바로 전송
      // Why: sessionStorage is lost across the redirect, so we send right now.
      var payload = {
        email:        emailInput    ? emailInput.value.trim()    : '',
        first_name:   firstName,
        last_name:    lastName,
        city_region:  cityInput     ? cityInput.value.trim()     : '',
        country:      countrySelect ? countrySelect.value        : '',
        phone:        phoneInput    ? phoneInput.value.trim()    : '',
        signup_event: klaviyoSignupEvt
      };

      // ── 3. 네이티브 제출 재시도 함수 (한 번만 실행되도록 플래그로 보호) ──
      // ── 3. Proceed function to re-submit natively (idempotent via flag) ──
      // setTimeout과 .finally 양쪽에서 호출될 수 있지만 한 번만 실행됨
      // Called by both setTimeout and .finally — executes only once due to the flag.
      var proceed = function () {
        if (klaviyoHandled) return;
        klaviyoHandled = true;

        // requestSubmit으로 HTML5 유효성 검사 포함 네이티브 제출 재현
        // Use requestSubmit to replay native submission including commit button and validation.
        // form.submit()은 HTML5 유효성 검사를 우회하므로 폴백으로만 사용
        // form.submit() bypasses HTML5 validation — used only as a fallback.
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(submitBtn || undefined);
        } else {
          form.submit();
        }
      };

      // ── 4. Klaviyo 전송 후 즉시 제출 (resolve/reject 모두 처리) ──
      // ── 4. Submit immediately after Klaviyo resolves or rejects ──
      fireKlaviyoIdentify(payload).finally(proceed);

      // 안전 타이머: Klaviyo가 1500ms 내 응답 없을 경우 제출 강행
      // Safety cap: force submission if Klaviyo does not respond within 1500ms.
      setTimeout(proceed, 1500);
    });
  }

  /* ============================================================
     페이지 로드 시 성공 감지 / On load: detect success
     ?customer_posted=true 파라미터로 성공 여부 판단
     Determine success from the ?customer_posted=true URL parameter.
     Klaviyo는 이미 네비게이션 전에 전송됨 — 여기서는 재호출하지 않음
     Klaviyo was already sent pre-navigation — it is NOT called again here.
     ============================================================ */

  (function detectSuccess() {
    var params = new URLSearchParams(window.location.search);

    if (params.get('customer_posted') !== 'true') return;

    // 폼 오류 요소가 있으면 모달 대신 오류에 포커스
    // If form error element exists, focus it instead of opening the modal.
    var formErrors = document.getElementById('EventSignup-form-error');
    if (formErrors) {
      formErrors.focus();
      return;
    }

    // 오류 없음 → 성공 모달 표시
    // No errors → show success modal.
    openModal();
  })();

  /* ============================================================
     Klaviyo client-side Identify 전송 / Fire Klaviyo client-side Identify
     네비게이션 전에 호출 — 페이지가 아직 안정된 상태
     Called before navigation — the page is still stable.
     keepalive: true 로 네이티브 제출이 시작된 후에도 요청이 완료되도록 보장
     keepalive: true ensures the request completes even if native submission starts
     (belt-and-suspenders for the 1500ms safety-cap path).
     ============================================================ */

  /**
   * Klaviyo v3 Profiles API를 통해 프로필을 식별함
   * Identifies a profile via the Klaviyo v3 Profiles API.
   *
   * location 객체를 사용하지 않음 — Shopify 통합이 덮어쓰기 때문
   * Does NOT use the standard location object — the Shopify integration overwrites it.
   * 이벤트에서 입력된 값은 커스텀 속성으로만 저장하여 덮어쓰기 방지
   * Event-entered values are stored ONLY as custom properties so they are never overwritten:
   *   city_region → properties.city_region
   *   country     → properties.signup_country
   *   phone       → properties.phone
   *
   * @param {Object} data - 폼 live 입력값 / live form input values
   * @returns {Promise} Klaviyo fetch Promise (항상 resolve, 에러는 무시 / always resolves, errors silenced)
   */
  function fireKlaviyoIdentify(data) {
    // Klaviyo v3 client-side Profiles API 엔드포인트
    // Klaviyo v3 client-side Profiles API endpoint.
    var endpoint = 'https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(klaviyoKey);

    // 커스텀 프로퍼티 구성 — 빈 값은 포함하지 않음
    // Build custom properties — omit empty values.
    var properties = {};
    if (data.signup_event) properties.signup_event    = data.signup_event;
    if (data.city_region)  properties.city_region     = data.city_region;
    if (data.country)      properties.signup_country  = data.country;
    if (data.phone)        properties.phone           = data.phone;

    // 최상위 속성 구성 — 빈 값은 포함하지 않음
    // Build top-level attributes — omit empty values.
    var attributes = {};
    if (data.email)      attributes.email      = data.email;
    if (data.first_name) attributes.first_name = data.first_name;
    if (data.last_name)  attributes.last_name  = data.last_name;

    // 커스텀 프로퍼티가 있는 경우에만 포함
    // Only include properties object when there is at least one custom property.
    if (Object.keys(properties).length > 0) {
      attributes.properties = properties;
    }

    var payload = {
      data: {
        type:       'profile',
        attributes: attributes
      }
    };

    // keepalive: true — 네이티브 제출이 시작되어도 요청이 완료되도록 보장
    // keepalive: true — ensures the request survives even if native form submission starts.
    // .catch로 에러를 무시 — 항상 .finally가 실행되어 폼 제출이 이루어짐
    // .catch silences errors — .finally always runs so form submission always proceeds.
    return fetch(endpoint, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      keepalive: true,
      body:    JSON.stringify(payload)
    }).catch(function () {
      // Klaviyo 오류는 무시 — 페이지 흐름을 방해하지 않음
      // Silently ignore Klaviyo errors — must not break the page flow.
    });
  }

  /* ============================================================
     모달 열기/닫기 / Modal open / close
     ============================================================ */

  // 모달을 여는 직전의 포커스 요소를 추적 (포커스 복원용)
  // Track the element focused before opening (for focus restoration on close).
  var previouslyFocused = null;

  /**
   * 성공 모달 열기 / Open success modal.
   * 배경을 inert로 설정하고, 모달로 포커스 이동
   * Sets background inert, moves focus into the modal.
   */
  function openModal() {
    if (!overlay || !modal) return;

    previouslyFocused = document.activeElement;

    // 오버레이 표시 (display: flex via CSS class)
    // Show overlay (display: flex via CSS class).
    overlay.classList.add('is-open');
    overlay.removeAttribute('aria-hidden');

    // 페이지 나머지를 inert로 설정하여 포커스 트랩
    // Set the rest of the page inert to trap focus.
    setPageInert(true);

    // 다음 프레임에 opacity 전환 적용 (CSS transition 트리거)
    // Apply opacity transition on next frame to trigger CSS transition.
    requestAnimationFrame(function () {
      overlay.classList.add('is-visible');
    });

    // 모달 다이얼로그에 포커스 이동
    // Move focus into the modal dialog.
    modal.focus();

    // 키보드 이벤트 리스너 등록
    // Register keyboard event listener.
    document.addEventListener('keydown', handleModalKeydown);
  }

  /**
   * 성공 모달 닫기 / Close success modal.
   * 포커스를 이전 요소로 복원
   * Restores focus to the previously focused element.
   *
   * transitionend 이벤트가 발생하지 않을 경우를 대비한 setTimeout 폴백 포함
   * Includes a setTimeout fallback in case transitionend never fires
   * (e.g. prefers-reduced-motion or zero-duration transitions).
   */
  function closeModal() {
    if (!overlay || !modal) return;

    overlay.classList.remove('is-visible');

    // CSS transition 지속 시간과 동일한 폴백 타이머 (기본값 250ms)
    // Fallback timer matching the CSS transition duration (default 250ms).
    var CSS_DURATION_MS = 250;
    var fallbackTimer = setTimeout(function () {
      finaliseClose();
    }, CSS_DURATION_MS + 50);

    // transition 완료 후 display: none 적용 — 폴백보다 먼저 발생하면 타이머 취소
    // Apply display: none after transition completes — cancel fallback if it fires first.
    overlay.addEventListener('transitionend', function handler() {
      clearTimeout(fallbackTimer);
      overlay.removeEventListener('transitionend', handler);
      finaliseClose();
    });

    // 페이지 inert 해제
    // Remove page inert.
    setPageInert(false);

    // 키보드 이벤트 리스너 제거
    // Remove keyboard event listener.
    document.removeEventListener('keydown', handleModalKeydown);

    // 포커스 복원 / Restore focus.
    if (previouslyFocused && previouslyFocused.focus) {
      previouslyFocused.focus();
    }
  }

  /**
   * 모달 DOM 정리 — is-open 제거 및 aria-hidden 복원
   * Finalise modal DOM state — remove is-open and restore aria-hidden.
   * closeModal에서 transitionend 또는 setTimeout 폴백으로 호출됨
   * Called from closeModal via transitionend or the setTimeout fallback.
   */
  function finaliseClose() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
  }

  /* ============================================================
     페이지 inert 설정 / Page inert toggle
     모달이 열려있는 동안 배경 요소에 inert 적용
     Applies inert to background elements while modal is open.
     ============================================================ */

  function setPageInert(inert) {
    // 모달 오버레이를 포함하지 않는 body 자식 요소들을 inert로 설정
    // Set body children that do not contain the overlay to inert.
    var siblings = Array.from(document.body.children);
    siblings.forEach(function (el) {
      if (!el.contains(overlay)) {
        el.inert = inert;
      }
    });

    // 모달 오버레이 자체는 inert 해제
    // Ensure the modal overlay itself is NOT inert.
    if (overlay) {
      overlay.inert = false;
    }
  }

  /* ============================================================
     모달 키보드 핸들링 / Modal keyboard handling
     ============================================================ */

  /**
   * Esc 키로 닫기, Tab으로 포커스 트랩
   * Close on Esc, trap focus with Tab.
   */
  function handleModalKeydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }

    if (event.key === 'Tab') {
      trapFocus(event);
    }
  }

  /**
   * 모달 내 포커스 트랩
   * Focus trap inside the modal.
   */
  function trapFocus(event) {
    if (!modal) return;

    // 모달 내 포커스 가능한 모든 요소 / All focusable elements inside the modal.
    var focusableSelectors = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(', ');

    var focusable = Array.from(modal.querySelectorAll(focusableSelectors));
    if (!focusable.length) return;

    var first = focusable[0];
    var last  = focusable[focusable.length - 1];

    if (event.shiftKey) {
      // Shift+Tab: 첫 번째 요소에서 마지막으로 이동
      // Shift+Tab: wrap from first to last.
      if (document.activeElement === first) {
        event.preventDefault();
        last.focus();
      }
    } else {
      // Tab: 마지막 요소에서 첫 번째로 이동
      // Tab: wrap from last to first.
      if (document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  /* ============================================================
     모달 닫기 버튼 이벤트 / Modal close button events
     ============================================================ */

  if (closeBtn) {
    closeBtn.addEventListener('click', closeModal);
  }

  if (doneBtn) {
    doneBtn.addEventListener('click', closeModal);
  }

  // 오버레이 클릭으로 닫기 (모달 다이얼로그 영역 외부)
  // Close by clicking the overlay backdrop (outside the dialog).
  if (overlay) {
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) {
        closeModal();
      }
    });
  }

})();
